import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import styled from 'styled-components';
import { Column } from '~common/components/column.component';

interface Props {
  name: string;
  onRemove?: VoidFunction;
}

export const SponsorPreview: React.FunctionComponent<Props> = ({ name, onRemove }) => {
  return (
    <Field
      name={name}
      render={(renderProps): ReactNode => {
        const { input } = renderProps;
        const { value } = input;
        return (
          <Container onClick={onRemove} {...renderProps}>
            <Image src={value.icon.url} alt={value.url} />
          </Container>
        );
      }}
    />
  );
};

const Container = styled(Column)`
  height: 150px;
  width: 150px;
  align-items: center;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  margin-top: 16px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;



// WEBPACK FOOTER //
// ./view/components/details/sponsor-details/sponsor-preview.component.tsx